export enum TEAMS_ACTIONS {
  getAccountTeams = 'teams/getAccountTeams',
  getTeam = 'teams/getTeam',
  assignUserGroupToTeam = 'teams/assignUserGroupToTeam',
  updateFeatureFlags = 'teams/updateFeatureFlags'
}
